/**
 * Created by akirilyuk on 9/13/16.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        BaseCollection = require("collections/BaseCollection"),
        CommentModel = require("connection-models/ticketTab/CommentModel"),
        TicketModel = require("connection-models/ticketTab/TicketModel"),
        CommentsCollection = {};
    LE.module("LEConnection", function (_) {
        CommentsCollection = BaseCollection.extend({
            model:CommentModel,
            initialize: function(models, options){
                this.ticketReference = options.ticketModel;
                this._bindEvents();
            },
            _bindEvents: function(){
                this.listenTo(this.ticketReference,"change:"+TicketModel.KEYS.CUSTOMER_COMMENTS,this._onCommentsChange);
                this.listenTo(this.ticketReference,"change:"+TicketModel.KEYS.SUPPORT_COMMENTS,this._onCommentsChange);
            },
            _onCommentsChange: function(){
                this.reset(this.ticketReference.getAllComments());
            },
            comparator: function(model){
                return -model.getCreatedDate();
            }
        });
    });

    return CommentsCollection;
});
